document.addEventListener('DOMContentLoaded', initializeProductCarousel);
document.addEventListener('ProductSetUpdated', initializeProductCarousel);

function initializeProductCarousel() {

  const slider_components = document.querySelectorAll('slider-component');
  slider_components.forEach( function (slider_component) {    
    const slider_scroll_buttons_container = slider_component.querySelector('.slider-buttons');
    const slider_slide_container = slider_component.querySelector('ul');
    
    const slider_layout_buttons_containers = slider_component.querySelectorAll('.slider-button-layout');
    slider_layout_buttons_containers.forEach( function (slider_layout_buttons_container) { 
      
      const slider_layout_buttons = slider_layout_buttons_container.querySelectorAll('button.slider-button--layout');
      slider_layout_buttons.forEach( function (layout_button) {
        
        layout_button.addEventListener('click', function(e) {          
          const layout = layout_button.name;
          const cols = layout_button.getAttribute('data-columns_grid__scroll').split(":");
          const col_scroll = cols[0];
          const col_grid = cols[1];
          
          for (let i = 0; i < slider_layout_buttons.length; i++) {
            slider_layout_buttons[i].classList.remove('active');
          }
          layout_button.classList.add('active');

          if (layout == 'desktop_scroll') {
            slider_component.classList.remove('desktop_grid');
            slider_component.classList.add('desktop_scroll');
            
            if (slider_scroll_buttons_container.hasAttribute("show_desktop_slider")) { 
              slider_scroll_buttons_container.classList.remove('d-none');
            }
            slider_slide_container.classList.remove('grid--' + col_grid + '-col-desktop');
            slider_slide_container.classList.add('slider--desktop');
            slider_slide_container.classList.add('grid--' + col_scroll + '-col-desktop');
          } else if (layout == 'mobile_scroll') {
            slider_component.classList.remove('mobile_grid');
            slider_component.classList.add('mobile_scroll');
            slider_slide_container.classList.remove('grid--' + col_grid + '-col-tablet-down');
            slider_slide_container.classList.add('grid--' + col_scroll + '-col-tablet-down');
            slider_slide_container.classList.add('slider--tablet');
            slider_slide_container.classList.add('grid--peek');
          } else if (layout == 'desktop_grid') {
            slider_component.classList.remove('desktop_scroll');
            slider_component.classList.add('desktop_grid');
            slider_scroll_buttons_container.classList.add('d-none');
            slider_slide_container.classList.remove('slider--desktop');
            slider_slide_container.classList.remove('grid--' + col_scroll + '-col-desktop');
            slider_slide_container.classList.add('grid--' + col_grid + '-col-desktop');
          } else if (layout == 'mobile_grid') {
            slider_component.classList.remove('mobile_scroll');
            slider_component.classList.add('mobile_grid');
            slider_slide_container.classList.remove('grid--' + col_scroll + '-col-tablet-down');
            slider_slide_container.classList.remove('slider--tablet');
            slider_slide_container.classList.remove('grid--peek');
            slider_slide_container.classList.add('grid--' + col_grid + '-col-tablet-down');
            
          }

        });
      });
    });
  });
}